module.exports = __webpack_public_path__ + "static/slick1-63f25bf46172f3e949ccd7673475b4e3.png";